import { EntityTypeName } from "@odata/GeneratedEntityTypes";
import { getEnumNameSpaceName } from "@odata/GeneratedEnums.utils";

export const VatRuleTranslationFiles = [
    "Vats",
    getEnumNameSpaceName(EntityTypeName.VatReverseCharge),
    getEnumNameSpaceName(EntityTypeName.VatStatus),
];